import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';

export default Vue.component('check-unsaved', {
  template: require('./template.html'),
  name: 'check-unsaved',
  computed: {
    ...mapGetters([
      'currentPage',
      'currentSite',
      'initialCurrentPage',
    ]),
  },
  mixins: [modals, guid],
  props: ['modal'],
  data() {
    return {
      screenSize: 0,
      loading: false,
    };
  },
  watch: {
    modal(o) {
      this.$store.dispatch('setGlobalOpenModal', o);
    },
  },
  methods: {
    async checkPage(choice) {
      if (choice === 'yes') {
        const isDroplet = !this._pageTypes.includes(this.currentPage.type);
        if (!isDroplet) {
          // revert the droplet count to the initial value
          await this.$store.dispatch('revertDropletCounts', {
            site: this.currentSite,
          });
          // revert all page data to the initial value
          await this.$store.dispatch('revertPage', this.initialCurrentPage);
        } else {
          // this will revert a droplet to when it was loaded
          const index = _.findIndex(this.currentSite.recycled, r => r._id === this.currentPage._id);
          const $vm = this;
          this.$store.dispatch('runStateFn', {
            fn() {
              $vm.currentSite.recycled.splice(index, 1, $vm.initialCurrentPage);
            },
          });
        }
        this.$store.dispatch('updateInitialPage');
        this.$emit('toggle-modal');
        this.$router.push({ path: '/websites' });
      }
      if (choice === 'no') {
        this.$emit('toggle-modal');
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/check-unsaved/index.js